import { Injectable } from '@angular/core';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';
import { Firestore, doc, setDoc, updateDoc, serverTimestamp } from '@angular/fire/firestore';

/**
 * Lightweight online/offline presence:
 * - online=true on auth
 * - online=false on unload / tab hidden
 * Make sure users/{uid} exists (setDoc with merge).
 */
@Injectable({ providedIn: 'root' })
export class PresenceService {
  private initialized = false;
  private userData:any;

  constructor(private auth: Auth, private fs: Firestore) {}

  async init() {
  if (this.initialized) return;
  this.initialized = true;

  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  if (!userData?.uid) return;


      const uref = doc(this.fs, `users/${userData.uid}`);

      // ensure doc exists (minimal)
      await setDoc(
        uref,
        { uid: userData.uid, email: userData.email || null, lastSeen: serverTimestamp() },
        { merge: true }
      );

      // online true
      await updateDoc(uref, { online: true, lastSeen: serverTimestamp() });

      const goOffline = () => updateDoc(uref, { online: false, lastSeen: serverTimestamp() });

      window.addEventListener('beforeunload', goOffline);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) goOffline();
        else updateDoc(uref, { online: true, lastSeen: serverTimestamp() });
      });
}

}
